import { TableColumn } from '@shared';
import { COLORS } from '@shared/constants';

export const TECH_MAGIC_PLAYLIST_COLUMNS: TableColumn[] = [
    {
        field: 'playlistName',
        header: 'Playlist Name',
        width: '150px',
        hasRedirect: true,
    },
    {
        field: 'publishedDate',
        header: 'Published Date',
        width: '150px',
    },
    {
        field: 'assignedTo',
        header: 'Assigned To',
        width: '150px',
    },
    {
        field: 'totalContent',
        header: 'Total Content',
        width: '150px',
    },
    {
        field: 'actions',
        header: 'Actions',
        width: '150px',
        type: 'actions',
        actions: [
            // {
            //     icon: 'pencil-box',
            //     name: 'Edit',
            //     size: 13,
            //     color: COLORS.primary,
            // },
            {
                icon: 'outline-trash',
                name: 'Delete',
                size: 13,
                color: COLORS.danger,
            },
            {
                icon: 'upload',
                name: 'Push Updates',
                size: 13.5,
                color: COLORS.primary,
            },
        ],
    },
];

export const PLAYLISTS_TABLE_COLUMNS: TableColumn[] = [
    { field: 'dealerAlias', header: 'Dealer Alias', width: '150px', hasRedirect: true },
    {
        field: 'businessName',
        header: 'Business Name',
        width: '100px',
        hasRedirect: true,
    },
    { field: 'contantPerson', header: 'Contact Person', width: '150px' },
    { field: 'age', header: 'Age', width: '100px' },
    {
        field: 'licenses',
        header: 'Licenses',
        children: [
            {
                field: 'total',
                header: 'Total',
            },
            {
                field: 'unassigned',
                header: 'Unassigned',
            },
            {
                field: 'online',
                header: 'Online',
            },
            {
                field: 'offline',
                header: 'Offline',
            },
        ],
    },
    // {
    //     field: 'hosts',
    //     header: 'Hosts',
    //     children: [
    //         {
    //             field: 'total',
    //             header: 'Total',
    //         },
    //         {
    //             field: 'scheduled',
    //             header: 'Scheduled',
    //         },
    //         {
    //             field: 'active',
    //             header: 'Active',
    //         },
    //     ],
    // },
    {
        field: 'advertisers',
        header: 'Advertisers',
        children: [
            {
                field: 'total',
                header: 'Total',
            },
            {
                field: 'active',
                header: 'Active',
            },
        ],
    },
    { field: 'status', header: 'Status', width: '150px', type: 'status' },
    {
        field: 'actions',
        header: 'Actions',
        width: '150px',
        type: 'actions',
        actions: [
            // {
            //     icon: 'screenshot',
            //     name: 'Screenshot',
            //     size: 15,
            //     color: COLORS.primary,
            // },
            {
                icon: 'outline-trash',
                name: 'Delete',
                size: 15,
                color: COLORS.danger,
                hightlighLabel: true,
            },
        ],
    },
];
